<template>
  <div class="problem-record">
    <a-table :loading="spinning" :columns="columns" :pagination="pagination" :data-source="records" size="middle" row-key="index" @change="handleTableChange">
      <template slot="number" slot-scope="record">
        {{ record.index }}
      </template>
      <template slot="operator" slot-scope="operator">
        {{ operator ? operator.nickname : '系统' }}
      </template>
      <template slot="diffItem" slot-scope="record">
        <div v-for="(item, key) in record.value_diff" :key="key">
          {{ item.label }}
        </div>
      </template>
      <template slot="before" slot-scope="record">
        <div v-for="(item, key) in record.value_diff" :key="key">
          <diff-item-renderer :type="item.value" :value="item.before" preview-text="「变更前」查看详情" @preview="onPreview" />
        </div>
      </template>
      <template slot="after" slot-scope="record">
        <div v-for="(item, key) in record.value_diff" :key="key">
          <diff-item-renderer :type="item.value" :value="item.after" preview-text="「变更后」查看详情" @preview="onPreview" />
        </div>
      </template>
    </a-table>
    <preview-modal ref="previewModal" />
  </div>
</template>

<script>
import { problemRecord } from '@/api/event/problem';
import PreviewModal from '@/pages/project/components/PreviewModal';
import DiffItemRenderer from './DiffItemRenderer';

const RECORD_ITEMS = {
  title: { value: 'title', label: '标题' },
  status: { value: 'status', label: '状态' },
  urgency: { value: 'urgency', label: '紧急程度' },
  channel: { value: 'channel', label: '反馈渠道' },
  frequency: { value: 'frequency', label: '出现频率' },
  solver: { value: 'solver', label: '解决人' },
  handler: { value: 'handler', label: '处理人' },
  reporter: { value: 'reporter', label: '反馈人' },
  content: { value: 'content', label: '描述' },
  summary: { value: 'summary', label: '总结' },
  tags: { value: 'tags', label: '标签' },
  domains: { value: 'domains', label: '业务域' },
  projects: { value: 'projects', label: '项目' },
  attribution: { value: 'attribution', label: '归因' },
  problem_type: { value: 'problem_type', label: '类型' },
  started_time: { value: 'started_time', label: '开始时间' },
  reported_time: { value: 'reported_time', label: '上报时间' },
  resolved_time: { value: 'resolved_time', label: '解决时间' },
  discovered_time: { value: 'discovered_time', label: '发现时间' },
  located_time: { value: 'located_time', label: '定位时间' },
  confirmed_time: { value: 'confirmed_time', label: '业务确认时间' }
};

const problemRecordColumns = [
  {
    title: '序号',
    width: 50,
    align: 'center',
    scopedSlots: { customRender: 'number' }
  },
  {
    title: '操作人',
    width: 70,
    dataIndex: 'operator',
    key: 'operator',
    scopedSlots: { customRender: 'operator' }
  },
  {
    title: '操作时间',
    width: 160,
    key: 'created_time',
    dataIndex: 'created_time'
  },
  {
    title: '变更类型',
    width: 100,
    key: 'operation_alias',
    dataIndex: 'operation_alias'
  },
  {
    title: '变更项',
    width: 100,
    scopedSlots: { customRender: 'diffItem' }
  },
  {
    title: '变更前',
    width: 180,
    scopedSlots: { customRender: 'before' }
  },
  {
    width: 180,
    title: '变更后',
    scopedSlots: { customRender: 'after' }
  }
];

export default {
  name: 'ProblemRecord',
  components: {
    PreviewModal,
    DiffItemRenderer
  },
  props: {
    sourceId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      columns: problemRecordColumns,
      spinning: true,
      records: [],
      pagination: {
        size: 'small',
        total: 0,
        pageSize: this.$store.getters.pageSize,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: total => `共 ${total} 条`
      }
    };
  },
  computed: {
    diff() {
      return data => {
        const items = [];
        const itemKeys = Object.keys(RECORD_ITEMS);
        for (const key in data) {
          if (itemKeys.includes(key)) {
            items.push({
              ...RECORD_ITEMS[key],
              ...data[key]
            });
          }
        }
        return items;
      };
    }
  },
  created() {
    if (this.sourceId !== null) {
      this.getProblemRecord();
    }
  },
  methods: {
    async getProblemRecord() {
      try {
        this.spinning = true;
        const res = await problemRecord({
          id: this.sourceId,
          page_size: this.pagination.pageSize,
          page_number: this.pagination.current
        });

        this.pagination.total = res.data.total;
        this.records = res.data.items.map((record, index) => ({
          index: index + 1,
          ...record,
          value_diff: this.diff(record.value_diff)
        }));
      } catch (error) {
        this.$message.error('获取问题记录失败');
        console.error('获取问题记录失败:', error);
      } finally {
        this.spinning = false;
      }
    },

    onPreview(content, type) {
      const titleMap = {
        content: '描述',
        attribution: '归因分析'
      };
      this.$nextTick(() => {
        this.$refs.previewModal.onOpen(content, titleMap[type] || '详情');
      });
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getProblemRecord();
    }
  }
};
</script>

<style lang="less" scoped>
.problem-record {
  padding: 0;

  .ant-table {
    background: #fff;
    border-radius: 4px;
  }

  .ant-spin-nested-loading {
    background: #fff;
    padding: 16px;
    border-radius: 4px;
  }
}
</style>
